import React from 'react';

const FarmerRegisterSection = () => {
  return (
    <div className='px-4 md:px-24 md:mt-6 mt-3'>
      {/* Heading and View More */}
      {/* Heading */}
     <a href='/RegisterAsFarmMain'>
     <div className="flex md:gap-4 gap-1 items-center md:mb-6 mb-2">
        <h2 className="text-[#03897B] text-[10px] md:text-[32px] font-bold">
        REGISTER AS AN ENTERPRENEUR
        </h2>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746386728/Expand_right_14_xsloli.png"
          alt="l"
          className="md:w-[57px] md:h-[59px] h-[13px] w-[13px]"
        />
      </div>
     </a>

   <a href='/RegisterAsFarmMain'>
   <div className="relative md:h-[264px] h-[130px] w-full overflow-hidden rounded-md">
        {/* Cover Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745839151/image_61_rgdxnt.png"
          alt="Cover"
          className="h-full w-full object-cover"
        />

        {/* Small Top Left Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745839146/image_62_wue88q.png"
          alt="Small"
          className="absolute top-4 left-6 w-[80px] md:w-[190px] h-[80px] md:h-[160px] object-cover rounded-md shadow-md"
        />

        {/* Bottom Bar */}
        <div className="absolute bottom-0 left-0 md:h-[81px]  h-[30px] w-full flex">
          {/* Orange Text Box */}
          <div className="bg-[#E27B24] flex-1 flex items-center px-4 md:px-6 py-2">
            <p className="text-white text-[6px] md:text-[20px] font-light leading-tight">
              Registering as a farmer offers several key benefits that can significantly improve farm
              management and sustainability. Here are some reasons why registering is valuable:
            </p>
          </div>

          {/* Expand Icon */}
          <a    href='/RegisterAsFarmMain' className="bg-[#03897B] w-[32px] md:w-[81px] flex items-center justify-center">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745839127/Expand_right_fbdfbm.png"
              alt="Expand Icon"
              className="w-[20px] md:w-[57px] h-[20px] md:h-[59px]"
            />
          </a>
        </div>
      </div>
   </a>
    </div>
  );
};

export default FarmerRegisterSection;
